import React from "react";
import { Button } from "../components/ui";
import "./ApiNotices.css";

// Non-blocking notice shown while the session could not be verified (NA-036).
// It never signs anyone out and never replaces the page: it only explains why
// protected content is not available (or may be out of date) and offers Retry.
// `error` is a ME_STATUS of utils/api/users (network / server / invalid): all of
// them are retryable, a rejected token never reaches here (the context signs out).
const TEXT = {
  en: {
    pending: "We could not verify your session yet.",
    stale: "We could not refresh your access just now.",
    network: "Check your connection.",
    server: "The server is temporarily unavailable.",
    invalid: "The server sent an unexpected answer.",
    retry: "Retry",
  },
  ar: {
    pending: "تعذّر التحقق من جلستك حتى الآن.",
    stale: "تعذّر تحديث صلاحياتك الآن.",
    network: "تحقق من اتصالك بالإنترنت.",
    server: "الخادم غير متاح مؤقتًا.",
    invalid: "أرسل الخادم ردًا غير متوقع.",
    retry: "إعادة المحاولة",
  },
};

const RETRYABLE = new Set(["network", "server", "invalid"]);

export function SessionNotice({ lang = "en", error, verified, onRetry }) {
  if (!error) return null;
  const text = TEXT[lang] || TEXT.en;
  return (
    <div
      role="status"
      aria-live="polite"
      className="session-notice"
      dir={lang === "ar" ? "rtl" : "ltr"}
      lang={lang}
      data-testid="session-notice"
    >
      <span>
        {verified ? text.stale : text.pending} {text[error] || ""}
      </span>
      {RETRYABLE.has(error) && typeof onRetry === "function" ? (
        <Button variant="primary" appearance="filled" onClick={onRetry}>
          {text.retry}
        </Button>
      ) : null}
    </div>
  );
}

export default SessionNotice;
